import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom card-stretch mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header align-items-center border-0 mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-dark fs-3" }, "Milestones"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-2 fw-bold fs-6" }, "890,344 Sales")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "d-flex flex-wrap flex-xxl-nowrap justify-content-center justify-content-md-start pt-4" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"me-sm-10 me-0\"><ul class=\"nav flex-column nav-pills nav-pills-custom\"><li class=\"nav-item mb-3\"><a class=\"nav-link active w-225px h-70px\" data-bs-toggle=\"pill\" id=\"kt_stats_widget_2_tab_1\" href=\"#kt_stats_widget_2_tab_1_content\"><div class=\"nav-icon me-3\"><img alt=\"\" src=\"media/svg/logo/gray/aven.svg\" class=\"default\"><img alt=\"\" src=\"media/svg/logo/colored/aven.svg\" class=\"active\"></div><div class=\"ps-1\"><span class=\"nav-text text-gray-600 fw-bolder fs-6\"> Man&amp;Flower SaaS </span><span class=\"text-muted fw-bold d-block pt-1\"> HR Solutions </span></div></a></li><li class=\"nav-item mb-3\"><a class=\"nav-link w-225px h-70px\" data-bs-toggle=\"pill\" id=\"kt_stats_widget_2_tab_2\" href=\"#kt_stats_widget_2_tab_2_content\"><div class=\"nav-icon me-3\"><img alt=\"\" src=\"media/svg/logo/gray/tower.svg\" class=\"default\"><img alt=\"\" src=\"media/svg/logo/colored/tower.svg\" class=\"active\"></div><div class=\"ps-1\"><span class=\"nav-text text-gray-600 fw-bolder fs-6\"> Building Studio </span><span class=\"text-muted fw-bold d-block pt-1\"> HR Solutions </span></div></a></li><li class=\"nav-item mb-3\"><a class=\"nav-link w-225px h-70px\" data-bs-toggle=\"pill\" id=\"kt_stats_widget_2_tab_3\" href=\"#kt_stats_widget_2_tab_3_content\"><div class=\"nav-icon me-3\"><img alt=\"\" src=\"media/svg/logo/gray/fox-hub-2.svg\" class=\"default\"><img alt=\"\" src=\"media/svg/logo/colored/fox-hub-2.svg\" class=\"active\"></div><div class=\"ps-1\"><span class=\"nav-text text-gray-600 fw-bolder fs-6\"> Foxy Solutions </span><span class=\"text-muted fw-bold d-block pt-1\"> HR Solutions </span></div></a></li><li class=\"nav-item mb-5\"><a class=\"nav-link w-225px h-70px\" data-bs-toggle=\"pill\" id=\"kt_stats_widget_2_tab_4\" href=\"#kt_stats_widget_2_tab_4_content\"><div class=\"nav-icon me-3\"><img alt=\"\" src=\"media/svg/logo/gray/kanba.svg\" class=\"default\"><img alt=\"\" src=\"media/svg/logo/colored/kanba.svg\" class=\"active\"></div><div class=\"ps-1\"><span class=\"nav-text text-gray-600 fw-bolder fs-6\"> MyStreams </span><span class=\"text-muted fw-bold d-block pt-1\"> HR Solutions </span></div></a></li></ul></div>", 1)
const _hoisted_10 = { class: "tab-content flex-grow-1" }
const _hoisted_11 = {
  class: "tab-pane fade show active",
  id: "kt_stats_widget_2_tab_1_content"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-10\"><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Sale</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$650</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Commission</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$2,040</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Refers</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">8,926</span></div></div>", 1)
const _hoisted_13 = {
  class: "tab-pane fade",
  id: "kt_stats_widget_2_tab_2_content"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-10\"><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Sale</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$1250</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Commission</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$5,000</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Refers</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">4,926</span></div></div>", 1)
const _hoisted_15 = {
  class: "tab-pane fade",
  id: "kt_stats_widget_2_tab_3_content"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-10\"><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Sale</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$350</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Comission</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$1,200</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Refers</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">5,500</span></div></div>", 1)
const _hoisted_17 = {
  class: "tab-pane fade",
  id: "kt_stats_widget_2_tab_4_content"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-10\"><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Sale</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$450</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Comission</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">$6,500</span></div><div class=\"px-10\"><span class=\"text-muted fw-bold fs-7\">Refers</span><span class=\"text-gray-800 fw-bolder fs-3 d-block\">500</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown4 = _resolveComponent("Dropdown4")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown4)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_apexchart, {
              options: _ctx.chartOptions,
              series: _ctx.series1,
              height: "250",
              type: "bar"
            }, null, 8, ["options", "series"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_apexchart, {
              options: _ctx.chartOptions,
              series: _ctx.series2,
              height: "250",
              type: "bar"
            }, null, 8, ["options", "series"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_apexchart, {
              options: _ctx.chartOptions,
              series: _ctx.series3,
              height: "250",
              type: "bar"
            }, null, 8, ["options", "series"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_apexchart, {
              options: _ctx.chartOptions,
              series: _ctx.series4,
              height: "250",
              type: "bar"
            }, null, 8, ["options", "series"])
          ])
        ])
      ])
    ])
  ]))
}